import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Textbox,
  Custom,
  AsociacionTareaForma,
  Container
} from '@app/shared';


@Injectable()
export class DocumentFormsService {
  constructor() { }

  /**
   * Genera el formulario de agregar o modificar la asociacion
   *
   * @param {*} objectModel
   * @returns {BaseControl<any>[]}
   * @memberof DocumentFormsService
   */
   getFormFunctions(objectModel?: any): BaseControl<any>[] {
     let value: any = null;
     if(objectModel && objectModel.data && objectModel.data.requerido){
       if(objectModel.data.requerido == 'Sí'){
         value = true;
       }else{
         value = null;
       }
     }else{
       value = null;
     }
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'ngSelect',
        label: 'Función',
        order: 1,
        size: 'col-12 col-lg-6',
        template: objectModel.ngSelectTpl,
        value: objectModel ? objectModel.data ? objectModel.data.funcion ? objectModel.data.funcion : null : null : null,
        placeholder: 'Seleccione la función',
        validations: {
          validators: [Validators.required]
        }
      }),
      new Container({
        class: 'form-row form-check form-check-inline',
        order: 2,
        controls: [
          new Textbox({
            key: 'required',
            type: 'checkbox',
            label: 'Requerido',
            class: {
              container: ['pl-1']
            },
            value: value,
          })
        ]
      })
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  getMaxDocFunctions(objectModel?: any): BaseControl<any>[]{
    const controls: BaseControl<any>[] = [
      new Container({
        class: 'form-row',
        order: 1,
        key: 'max_documents',
        controls: [
          new Textbox({
            key: 'maxDocs',
            type: 'number',
            label: 'Número máximo de documentos a interactuar:',
            size: 'col-12 col-lg-4',
            customMin: 0,
            value: objectModel ? objectModel.data ? objectModel.data.maxdoc ? objectModel.data.maxdoc : 1 : 1 : 1,
            placeholder: 'Seleccione el máximo de documentos',
            describe: 'Ingrese únicamente números.',
            validations: {
              validators: [Validators.required, Validators.min(1)],
              messages: {
                min: 'El valor mínimo seleccionado debe ser 1'
              }
            },
          }),
        ]
      }),
    ];
    return controls.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/document-form/shared/document-form-component.forms.service.ts